export const getLoadingStatuses = (state) => state.generic.loadingStatuses;
export const getSavingStatus = (state) => state.generic.savingStatus;
export const getOrganizations = (state) => state.generic.organizations;
export const getCourseData = (state) => state.generic.createOrRerunCourse.courseData;
export const getCourseRerunData = (state) => state.generic.createOrRerunCourse.courseRerunData;
export const getRedirectUrlObj = (state) => state.generic.createOrRerunCourse.redirectUrlObj;
export const getPostErrors = (state) => state.generic.createOrRerunCourse.postErrors;
export const getClipboardData = (state) => state.generic.clipboardData;
